import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventCreateLocationState, EventCreateOrigin, newEventPath } from './paths'

/**
 * Opens the create-event flow on a Trip day, prefilled from an idea when one
 * is given, remembering where it was opened from so it returns there.
 */
export const useOpenEventCreate = (tripId: string, from: EventCreateOrigin) => {
	const navigate = useNavigate()
	return useCallback(
		(dayIndex: number, ideaId?: number) => {
			const state: EventCreateLocationState = { from }
			navigate(newEventPath(tripId, dayIndex, ideaId), { state })
		},
		[navigate, tripId, from],
	)
}
